import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16 26a7 7 0 01-6.94-6.13A6.36 6.36 0 019 19v-.44c1.14-1.08 3.3-2 7 .44s5.84 1.52 7 .44A7 7 0 0116 26z"/><path d="M26 2H6a3 3 0 00-3 3v23a2 2 0 002 2h22a2 2 0 002-2V5a3 3 0 00-3-3zM8 6h4a1 1 0 010 2H8a1 1 0 010-2zm8 22a9 9 0 119-9 9 9 0 01-9 9z"/>';
export var LaundrySVG = function LaundrySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LaundrySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LaundrySVG);